<template>
  <div :class="{'selected': selected}" class="service-box">
    <div class="texts">
      <span class="subtitle-bold">{{ fullName }}</span>
      <span style="margin: 0 0 0 0.75rem">{{ phoneNumber }}</span>
    </div>
    <div class="circle">
      <i :class="{'pi': true, 'pi-circle-fill': selected, 'pi-circle': !selected}"></i>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  fullName: {
    type: String,
    required: true
  },
  phoneNumber: {
    type: String,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.service-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0.75rem;
  width: 100%;
  height: auto;
  cursor: pointer;
  //background: v-bind(bgColor);
  border-radius: 0.5rem;
  //border: 1px solid v-bind(bgColor);
  //color: v-bind(fontColor);

  .texts {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    div {
      i {
        margin-left: 4px;
      }

      span {
        margin-left: 24px;
      }

      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
</style>
